/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { 
 
  Typography,
  Box,
  
  CircularProgress,
  
  TextField,
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import Footer from "examples/Footer";



import { changePassword } from 'api/getApi';
import { useState, useEffect } from 'react';
function ChangePassword() {

    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
  
    const onSubmit = async (data) => {
      try {
        setLoading(true);
        setErrorMessage('');
        setSuccessMessage('');
        
        await changePassword(data.newPassword, data.currentPassword);
        
        setSuccessMessage('Password changed successfully.');
        // Reset form
        document.getElementById("password-form").reset();
      } catch (error) {
        setErrorMessage(error.response?.data?.message || 'Error changing password');
      } finally {
        setLoading(false);
      }
    };
  return (
    <DashboardLayout>
  <MDBox pt={6} pb={3}>
    <Grid container spacing={6} justifyContent="center">
 
      <Grid item xs={12} md={8} lg={6}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Change Password
            </MDTypography>
          </MDBox>
          <MDBox pt={3}>
            <Box sx={{ width: '70%', overflow: 'hidden', mx: 'auto', textAlign: 'left' }}>
              <Box sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h4" gutterBottom>
                  Change Password
                </Typography>
                <form id="password-form" onSubmit={handleSubmit(onSubmit)}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Current Password"
                        type="password"
                        {...register('currentPassword', { required: 'Current Password is required' })}
                        error={!!errors.currentPassword}
                        helperText={errors.currentPassword?.message}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="New Password"
                        type="password"
                        {...register('newPassword', { 
                          required: 'New Password is required',
                          minLength: {
                            value: 6,
                            message: 'Password must be at least 6 characters long'
                          }
                        })}
                        error={!!errors.newPassword}
                        helperText={errors.newPassword?.message}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Confirm New Password"
                        type="password"
                        {...register('confirmPassword', {
                          validate: value => 
                            value === watch('newPassword') || 'Passwords do not match'
                        })}
                        error={!!errors.confirmPassword}
                        helperText={errors.confirmPassword?.message}
                      />
                    </Grid>

                    {errorMessage && (
                      <Grid item xs={12}>
                        <Typography color="error">{errorMessage}</Typography>
                      </Grid>
                    )}

                    {successMessage && (
                      <Grid item xs={12}>
                        <Typography color="primary">{successMessage}</Typography>
                      </Grid>
                    )}

                    <Grid item xs={12}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        fullWidth
                        style={{ color: "white" }} 
                        >
                        {loading ? <CircularProgress size={24} /> : "Change Password"}
                        </Button>

                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Box>
          </MDBox>
        </Card>
      </Grid>
    </Grid>
  </MDBox>
  <Footer />
</DashboardLayout>

  );
}

export default ChangePassword;
